import { createRoot } from "react-dom/client";
import { App } from "./App";
import {
  DbConnection,
  ErrorContext,
} from "@module-bindings";
import { Identity } from "spacetimedb";
import { SpacetimeDBProvider } from "spacetimedb/react";

const HOST = window.__APP_CONFIG.spacetimeDbUri;
const DB_NAME = window.__APP_CONFIG.spacetimeDbName;

const onConnect = (_conn: DbConnection, identity: Identity) => {
  console.log(
    "Connected to SpacetimeDB with identity:",
    identity.toHexString(),
  );
};

const onDisconnect = () => {
  console.log("Disconnected from SpacetimeDB");
};

const onConnectError = (_ctx: ErrorContext, err: Error) => {
  console.log("Error connecting to SpacetimeDB:", err);
};

const connectionBuilder = DbConnection.builder()
  .withUri(HOST)
  .withDatabaseName(DB_NAME)
  .onConnect(onConnect)
  .onDisconnect(onDisconnect)
  .onConnectError(onConnectError);

function start() {
  const root = createRoot(document.getElementById("root")!);
  root.render(
    <SpacetimeDBProvider connectionBuilder={connectionBuilder}>
      <App />
    </SpacetimeDBProvider>,
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
